// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../country-config/app/entity/CountryConfig.bs.js";
import * as OrderRepoConfig from "./OrderRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as FilterOrderRequestMapper from "../../../../root/crm/filter-order/view/FilterOrderRequestMapper.bs.js";

function fetchOrders_old(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/" + (msisdn + "/order_info"));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderRepoConfig.OrderListResponseConverter.execute, result);
                        });
            });
}

function fetchOrders(request, offset, country) {
  var urlParams = FilterOrderRequestMapper.DictEncoder.execute(request);
  FilterOrderRequestMapper.appendToParam(urlParams, "offset", offset);
  FilterOrderRequestMapper.appendToParam(urlParams, "payment_mode", Belt_Option.flatMap(request.is_business, (function (is_business) {
              if (is_business) {
                return "business_account";
              }
              
            })));
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/filter_orders_crm", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderRepoConfig.FilterOrderResponseConverter.execute, result);
                        });
            });
}

var OrderRepo = {
  fetchOrders_old: fetchOrders_old,
  fetchOrders: fetchOrders
};

export {
  OrderRepo ,
  
}
/* Config Not a pure module */
